import { deconstructNode } from '~/libs/contentful/helpers'
import { useState } from 'react'
import { TypeExpertTipV2 } from '~/types/contentful'

type ExpertTipV2Props = {
  expertTipV2: TypeExpertTipV2<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const ExpertTipV2 = ({ expertTipV2 }: ExpertTipV2Props) => {
  const { fields } = deconstructNode(expertTipV2) as TypeExpertTipV2<
    'WITHOUT_UNRESOLVABLE_LINKS',
    string
  >
  const { question, questionDescription, answer, answerDescription } = fields
  const [buttonText, setButtonText] = useState('Copy to Clipboard')

  const copyToClipboard = () => {
    if (answerDescription) {
      navigator.clipboard
        .writeText(answerDescription)
        .then(() => {
          setButtonText('Copied!')
          setTimeout(() => {
            setButtonText('Copy to Clipboard')
          }, 2000)
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err)
        })
    }
  }

  return (
    <div className="flex flex-col mt-6 justify-start gap-2 self-stretch">
      <div className="flex flex-col p-6 justify-start gap-2 self-stretch rounded-2xl bg-blue-10">
        <div className="flex items-center justify-between w-full">
          <span className="flex text-s text-center text-blue-60">{question}</span>
        </div>
        <p className="text-xs text-neutral-100">{questionDescription}</p>
      </div>
      <div className="flex flex-col p-6 justify-start gap-2 self-stretch rounded-2xl border border-green-30 border-dashed bg-green-10/50">
        <div className="flex items-center justify-between w-full">
          <span className="flex text-s text-center text-green-60">{answer}</span>
          <button
            className="flex py-1.5 px-3 items-center gap-2.5 bg-white text-blue-50 rounded border border-blue-20 hover:bg-blue-10 transition-colors"
            onClick={copyToClipboard}
          >
            <p className="text-[14px] leading-4 tracking-[0.3px]">{buttonText}</p>
          </button>
        </div>
        <p className="text-xs text-neutral-100">{answerDescription}</p>
      </div>
    </div>
  )
}
